import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, Button } from '@mui/material'
import { makeStyles } from '@mui/styles';
import { UpFontIcon } from '../../components/CustomIcons';
import theme, { commonFont } from '../../theme.css';
import CustomSection from '../../components/CustomSection';
import CustomTable from '../../components/CustomTable';
import CustomRadioButtonGroup from '../../components/CustomRadioButtonGroup';
import {cyan, red} from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
    main: {
        padding: theme.spacing(2),
        background: theme.palette.common.white,
    },
    //table: 
    cell: {
        fontFamily: commonFont.regular,
    },
    columnSeparator: {
        display: 'none!important'
    },
    box: {
        background: cyan['A400'],
        color: theme.palette.common.white,
        padding: theme.spacing(2, 3),
        borderRadius: theme.spacing(0.5)
    },
    text: {
        color: red[400],
    }
}));

export default function SwapServiceView(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const { options, selected, listDates, selectedDate, onChangeOption, onChangeDate } = props;
   
    return (
        <Grid item xs={12} className={classes.main}>
            <CustomSection notMarginTop={true} 
                title={t('btn_upgrade_downgrade')} 
                icon={<UpFontIcon style={{
                    color: theme.palette.common.white,
                }}/>}
                customClass={classes.customClass}
            >
                <Grid item xs={12} marginTop={1}>
                    <Typography variant='body2' className={classes.text}>{t('please_choose_one')}</Typography>
                </Grid>
                <Grid item xs={12} marginTop={1}>
                    <CustomRadioButtonGroup 
                        items={options}
                        selected={selected ? selected : null}
                        onChange={onChangeOption}
                    />
                </Grid>
                <Grid item xs={12} marginTop={1}>
                    <Button variant='contained' size='small' className={classes.button} onClick={() => props.onProceed()}>{t('btn_proceed')}</Button>
                </Grid>
            </CustomSection>
        </Grid>
    );
}
